// FLAG TO REGISTER POPUP
let popUpToken = false;
let acPopupToken = false;
let tangent_test_popup = false;
let cart_item_count=0;

// ALL SHADES POSSIBLE WITH IMAGE
var shades = {
  "Ivory":"https://a.tangent.ai/DND/AmazingCosmetics/shades/ivory_50x.webp",
  "GoldenIvory":"https://a.tangent.ai/DND/AmazingCosmetics/shades/golden-ivory_50x.webp",
  "Fair":"https://a.tangent.ai/DND/AmazingCosmetics/shades/fair_50x.webp",
  "FairGolden":"https://a.tangent.ai/DND/AmazingCosmetics/shades/fair-golden_50x.webp",
  "LightGolden":"https://a.tangent.ai/DND/AmazingCosmetics/shades/light-golden_50x.webp",
  "LightHoney":"https://a.tangent.ai/DND/AmazingCosmetics/shades/light-honey_50x.webp",
  "LightBeige":"https://a.tangent.ai/DND/AmazingCosmetics/shades/light-beige_50x.webp",
  "MediumBeige":"https://a.tangent.ai/DND/AmazingCosmetics/shades/medium-beige_50x.webp",
  "DarkBeige":"https://a.tangent.ai/DND/AmazingCosmetics/shades/dark-beige_50x.webp",
  "MediumGolden":"https://a.tangent.ai/DND/AmazingCosmetics/shades/medium-golden_50x.webp",
  "Tan":"https://a.tangent.ai/DND/AmazingCosmetics/shades/tan_50x.webp",
  "TanGolden":"https://a.tangent.ai/DND/AmazingCosmetics/shades/tan-golden_50x.webp",
  "MediumTan":"https://a.tangent.ai/DND/AmazingCosmetics/shades/medium-tan_50x.webp",
  "Caramel":"https://a.tangent.ai/DND/AmazingCosmetics/shades/caramel_50x.webp",
  "DeepGolden":"https://a.tangent.ai/DND/AmazingCosmetics/shades/deep-golden_50x.webp",
  "WarmDeep":"https://a.tangent.ai/DND/AmazingCosmetics/shades/warm-deep_50x.webp",
  "LightCaramel":"https://a.tangent.ai/DND/AmazingCosmetics/shades/light-caramel_50x.webp",
  "DarkCaramel":"https://a.tangent.ai/DND/AmazingCosmetics/shades/dark-caramel_50x.webp",
  "ROSE":"https://a.tangent.ai/DND/AmazingCosmetics/shades/rose_50x.webp",
  "GLOW":"https://a.tangent.ai/DND/AmazingCosmetics/shades/glow_50x.webp",
  "BRONZE":"https://a.tangent.ai/DND/AmazingCosmetics/shades/bronze_50x.webp"
}

let selected_pdt;

// FLAG TO LOAD RECOMMEND PAGE
let loadRecommend = false;

var products = [];

// TIMEOUT VARIABLE
var seconds = 0;

setTimeout(function(){
    isInViewport();
}, 7000);

// COOKIE STORAGE
let popup_cookie = getCookie('tangent_popup');

if(popup_cookie==null || popup_cookie=='false'){
  
  addPopupHtml();
  
  setTimeout(function(){ 
    document.addEventListener('mouseout', mouseEvent);

    document.addEventListener('keydown', exit);

    document.querySelector('.exit-intent-popup').addEventListener('click', exit);
    
  }, 7000);

}
var cart_url = "https://www.amazingcosmetics.co.uk/cart.json";
      

function isInViewport() {
  acPopupToken = false;
}


const mouseEvent = e => {
  const shouldShowExitIntent = 
        !e.toElement && 
        !e.relatedTarget &&
        e.clientY < 10;
  
  if (shouldShowExitIntent && !popUpToken) {
      if(!acPopupToken){
        showPopup();
      }
  }
  
};

const exit = e => {
  
  const shouldExit =
        [...e.target.classList].includes('exit-intent-popup') || // user clicks on mask
        e.target.className === 'close' || // user clicks on the close icon
        e.keyCode === 27; // user hits escape

  
  if (shouldExit) {
    document.querySelector('.exit-intent-popup').classList.remove('visible');
    document.getElementById("exit-intent-popup").style.display="none";    
  }

};

function setCookie(name,value,days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function eraseCookie(name) {   
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

let inactivityTime = function() {
  let time;
  window.onload = resetTimer;
  document.onmousemove = resetTimer;
  document.onkeypress = resetTimer;
  resetLongTimer();
  document.onload = resetTimer;
  document.ontouchstart = resetTimer;
  document.onclick = resetTimer;     // touchpad clicks
  document.onkeydown = resetTimer;   // onkeypress is deprectaed
  document.addEventListener('scroll', resetTimer, true); 
  
  function logout() {
    var touchDevice = ('ontouchstart' in document.documentElement); 
    if(touchDevice && !popUpToken){
        showPopup();
      	popUpToken = true;
    }
  }
  
  function resetTimer() {
    clearTimeout(time);
    time = setTimeout(logout, 5000);
  }
  
  function resetLongTimer(){
    clearTimeout(time);
    time = setTimeout(logout, 7000);
  }
};

window.onload = function() { inactivityTime(); }

function mainResetTimer() {
  clearTimeout(time);
  time = setTimeout(checkForStatus, 3000);
}

function checkForPopup() {
  var showpopup = true;
  $( "form.klaviyo-form button" ).each(function( index ) {
     if($( this ).html()=="GET CODE"){
       showpopup=false;
     }
  });

  if(showpopup){
    showPopup();
  }
}

function checkForStatus() {
  var touchDevice = ('ontouchstart' in document.documentElement);
  if(touchDevice && !popUpToken){
    showPopup();
  }
  popUpToken = true;
}

function showPopup(){
  if(popup_cookie==null || popup_cookie=='false'){
    let popupDiv = document.getElementById("exit-intent-popup");

    var cart_url = "https://www.amazingcosmetics.com/cart.json";
    fetch(cart_url).then(function(response) {
      return response.json();
    }).then(function(data) {
      cart_item_count = data.item_count;
      if(cart_item_count>0){
        popupDiv.innerHTML="<div id='popup-message-container'><h2 style='margin: 0;line-height: 40px;'>Exclusive offer for you, use the code FINISHCHECKOUT to get 20% OFF on your cart products</h2><span id='close_btn' class='close' onclick='close_pop()'><img src='https://a.tangent.ai/DND/AmazingCosmetics/exitpopup/Group_11.png' alt='Close' width='20'></span></div>";
      }
      else{
        popupDiv.innerHTML = "<div id='popup-container' class='tangent-newsletter'><iframe id='tangent' title='Selfie quiz' allow='camera' frameborder='0' allowtransparency='true' width='100%;' scrolling='no' style='overflow: hidden;min-height:400px' src='https://a.tangent.ai/quiz-app/1.0.18/?shop_id=2109692&amp;form_id=exitpopup'></iframe><div id='recommendation-section' class='hide'><p id='recommendation-heading'><span class='mob-hidden'>Thanks for your answers! </span><span>We think these will look amazing on you!</span></p><div id='loading' class='lds-facebook'><div></div><div></div><div></div></div><div id='main-div'><div class='row' id='products-section'></div><div id='right-div'><p class='mob-hidden' id='code-pre-text'>Your Coupon Code</p><p class='mob-hidden' id='offercode'>AC20</p><p class='mob-visible' id='code-pre-text'>Your Coupon Code <b>AC20</b></p><p id='add_all2cart'><a id='add-all-to-cart' href='#' class='Button Button--primary custom-add-to-cart-tangent'>ADD ALL TO CART</a></p><p id='disclaimer_text'>*discount code does not apply to gift cards and bundles</p></div></div></div><span id='close_btn' class='close' onclick='close_pop()'><img src='https://a.tangent.ai/DND/AmazingCosmetics/exitpopup/Group_11.png' alt='Close' width='20'></span></div>";
      }
    }).catch(function(err) {
      console.log('Fetch Error :-S', err);
      popupDiv.innerHTML = "<div id='popup-container' class='tangent-newsletter'><iframe id='tangent' title='Selfie quiz' allow='camera' frameborder='0' allowtransparency='true' width='100%;' scrolling='no' style='overflow: hidden;min-height:400px' src='https://a.tangent.ai/quiz-app/1.0.18/?shop_id=2109692&amp;form_id=exitpopup'></iframe><div id='recommendation-section' class='hide'><p id='recommendation-heading'><span class='mob-hidden'>Thanks for your answers! </span><span>We think these will look amazing on you!</span></p><div id='loading' class='lds-facebook'><div></div><div></div><div></div></div><div id='main-div'><div class='row' id='products-section'></div><div id='right-div'><p class='mob-hidden' id='code-pre-text'>Your Coupon Code</p><p class='mob-hidden' id='offercode'>AC20</p><p class='mob-visible' id='code-pre-text'>Your Coupon Code <b>AC20</b></p><p id='add_all2cart'><a id='add-all-to-cart' href='#' class='Button Button--primary custom-add-to-cart-tangent'>ADD ALL TO CART</a></p><p id='disclaimer_text'>*discount code does not apply to gift cards and bundles</p></div></div></div><span id='close_btn' class='close' onclick='close_pop()'><img src='https://a.tangent.ai/DND/AmazingCosmetics/exitpopup/Group_11.png' alt='Close' width='20'></span></div>";
    }); 	
    document.removeEventListener('mouseout', mouseEvent);
	popupDiv.style.display ="flex";
    document.querySelector('.exit-intent-popup').classList.add('visible');
    popUpToken = true;
    setCookie('tangent_popup','true',20);
  }
}

function addPopupHtml(){
  //Create the element using the createElement method.
  var popupDiv = document.createElement("div");
  //Set its unique ID.
  popupDiv.id = 'exit-intent-popup';
  popupDiv.classList.add("exit-intent-popup");
  // popupDiv.innerHTML = "<div id='popup-container' class='tangent-newsletter'><iframe id='tangent' title='Selfie quiz' allow='camera' frameborder='0' allowtransparency='true' width='100%;' scrolling='no' style='overflow: hidden;min-height:400px' src='https://a.tangent.ai/quiz-app/1.0.18/?shop_id=2109692&amp;form_id=exitpopup'></iframe><div id='recommendation-section' class='hide'><p id='recommendation-heading'><span class='mob-hidden'>Thanks for your answers! </span><span>We think these will look amazing on you!</span></p><div id='loading' class='lds-facebook'><div></div><div></div><div></div></div><div id='main-div'><div class='row' id='products-section'></div><div id='right-div'><p class='mob-hidden' id='code-pre-text'>Your Coupon Code</p><p class='mob-hidden' id='offercode'>AC20</p><p class='mob-visible' id='code-pre-text'>Your Coupon Code <b>AC20</b></p><p id='add_all2cart'><a id='add-all-to-cart' href='#' class='Button Button--primary custom-add-to-cart-tangent'>ADD ALL TO CART</a></p><p id='disclaimer_text'>*discount code does not apply to gift cards and bundles</p></div></div></div><span id='close_btn' class='close' onclick='close_pop()'><img src='https://a.tangent.ai/DND/AmazingCosmetics/exitpopup/Group_11.png' alt='Close' width='20'></span></div>";
  document.body.appendChild(popupDiv);  
}


function addExternalScripts(){
    var script = document.createElement('script');
    script.src = "https://code.jquery.com/jquery-3.6.0.min.js";
    document.head.appendChild(script);
}
   
function bindEvent(element, eventName, eventHandler) {
  if (element.addEventListener){
    element.addEventListener(eventName, eventHandler, false);
  } else if (element.attachEvent) {
    element.attachEvent('on' + eventName, eventHandler);
  }
}

// Listen to message from child window
bindEvent(window, 'message', function (e) {
  switch (typeof e.data) {
    case 'string':
      if(e.data.includes("resp_id")){
        loadRecommend = true;
        document.getElementById("tangent").style.display="none";
        document.getElementById("popup-container").style.boxShadow="none";
        document.getElementById("popup-container").style.width="600px";
        document.getElementById("recommendation-section").classList.remove("hide");
        var dt = JSON.parse(e.data);
        // LOAD PRODUCTS
        loadProducts(dt.resp_id);
      }
      break;
    case 'number':
      var height =  e.data;
      var ex_height = document.getElementById("tangent").style.height;
      if(height != ex_height && height!=0){
        document.getElementById("tangent").style.height = height+"px";
        // document.getElementById("popup-container").style.height = height+"px";
        document.getElementById("popup-container").style.height ="inherit";
      }
      if(height>300) { document.getElementById("tangent").style.minHeight = "unset"; }
      break;
    default:
      break;
  }

  if(loadRecommend){
    document.getElementById("tangent").style.display="none";
  }
});

function loadProducts(resp_id){
  if(resp_id != null){
    var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+resp_id;
    $.ajax(checkout_url, {
      success: function(data) {
        document.getElementById("recommendation-heading").style.display ="block";
        $('#selfie_img').attr('src', data.selfie_url);
        products = data.products;
        var allToCart = "https://www.amazingcosmetics.com/cart/add?id[]=";
        document.getElementById("loading").style.display ="none"; 
        if(products.length>0){
          document.getElementById("products-section").style.display ="flex";
          document.getElementById("right-div").style.display ="flex"; 
          var bootClassName = "col-lg-4";
          switch(products.length) {
            case 1:bootClassName = "col-lg-4";
              break;
            case 2:
              bootClassName = "col-lg-6";
              break;
            case 3:
              bootClassName = "col-lg-4";
              break;
            default:
              bootClassName = "col-lg-3";
          }
          $("#add-all-to-cart").show();
          selected_pdt = {};
          for(var p=0;p<products.length;p++){
            if(p==0){
              allToCart = allToCart + products[p].variants[0].id;
            }
            else{
              allToCart = allToCart + '&id[]='+products[p].variants[0].id;
            }
            
            // STORE GLOBALLY VARIANT FOR PRODUCT
            selected_pdt[products[p].id] = products[p].variants[0].id;
            var variants_div = document.createElement("div");
            variants_div.id = 'variants_div';
            variants_div.style.display = "none";
            if(products[p].variants.length>0){
              var variantsub_div = document.createElement("div");
              variants_div.appendChild(variantsub_div);
              var _variants = products[p].variants;
              if(_variants.length>1){
                variants_div.style.display = "block";
                for(var v=0;v<_variants.length;v++){
                  var v_img = document.createElement("img");
                  v_img.id = "variant_"+v+":product_"+p;
                  v_img.title = _variants[v].title;
                  v_img.addEventListener(
                     'click',
                     function() { changeVariant(this); },
                     false
                  );
                  if(v==0){
                    v_img.classList.add('selected-variant');
                  }
                  var key2search =  _variants[v].title;
                  key2search = key2search.replace(/ /g, "")
                  if(shades.hasOwnProperty(key2search)){
                    v_img.src = shades[key2search];
                    v_img.classList.add('shade-img');
                  	variantsub_div.appendChild(v_img);
                  }
                }
              }
            }
            $('#add-all-to-cart').attr('href', allToCart);
            $('#products-section').append('<div  class="'+bootClassName+' col-12"><a class="text-link" target="_blank" href="https://www.amazingcosmetics.com/products/'+products[p].handle+'"><p class="product-title"><b>'+products[p].title+'</b></p><img class="tangent-popup-product-img" src="'+products[p].images[0].src+'" ></a><div id="product_'+p+'"></div><div/>');
            $('#product_'+p).append(variants_div);
            var price_text = document.createElement("p");
            price_text.innerText = "$"+products[p].variants[0].price;
            price_text.classList.add('prdt-price');
            $('#product_'+p).append(price_text);
          }
        }
        else{
          document.getElementById("recommendation-heading").innerHTML = 'Thank you for completing our quiz, we will get back to you soon!';  
          document.getElementById("recommendation-heading").style.padding ="0";
          $('#products-section').hide();
          $('#right-div').hide();
        }
        if(data.description!=''){
          $("#checkout-description").show();
          $( "#checkout-description" ).html( data.description );
        }
      },
      error: function() {
        console.log("Error in server call");
      }
    });
  }
}

function close_pop(){
  document.querySelector('.exit-intent-popup').classList.remove('visible');	
  document.getElementById("exit-intent-popup").style.display="none";
}

function addToCart(pid){
  Shopify.addItem(pid, 1, function(event){
    console.log(event);
  });

  $("#"+pid).text("Added to Cart!");
  $("#"+pid).css({
    "background-color": "#56565b",
    "cursor"     : "none",
    "pointer-events": "none"
  });
}

function changeVariant(ele){
  var allToCart = "https://www.amazingcosmetics.com/cart/add?id[]=";
  var eleId = ele.id;
  var arr = eleId.split(":");
  var vIdText = arr[0];
  var pIdText = arr[1];
  
  var n = vIdText.lastIndexOf('_');
  var v_id = vIdText.substring(n + 1);
  
  var m = pIdText.lastIndexOf('_');
  var p_id = pIdText.substring(m + 1);
  
  var vId = parseInt(v_id);  
  var pId = parseInt(p_id);
  
  var pdt = products[pId];
  
  for(var i=0;i<products.length;i++){
    if(pdt.id==products[i].id){
       var var_id = pdt.variants[0].id;
      if(pdt.variants.length>0){
         var _variants = pdt.variants;
         if(_variants.length>1){
           for(var v=0;v<_variants.length;v++){
             if(ele.title==_variants[v].title){
               var_id = _variants[v].id;
             }
           }
         }
       } 
	   
       var c=0;
       for(var pid in selected_pdt){
         if(pid==pdt.id){
          selected_pdt[pid] = var_id;
       	 }
         if(c==0){ 
         	allToCart = allToCart + selected_pdt[pid];
         }
         else{
         	allToCart = allToCart + '&id[]='+selected_pdt[pid];
         }

         c=c+1;
      }
    }
  }
  
  var shade_imgs = document.getElementsByClassName('shade-img');
  for (var i = 0; i < shade_imgs.length; ++i) {
    var item = shade_imgs[i];  
    if(item.classList.contains('selected-variant')){
        var itemId = item.id;
        var arrSplit = itemId.split(":");
        var vItemIdText = arrSplit[0];
        var pdtIdText = arrSplit[1];

        var n = vItemIdText.lastIndexOf('_');
        var var_id = vItemIdText.substring(n + 1);

        var m = pdtIdText.lastIndexOf('_');
        var pdt_id = pdtIdText.substring(m + 1);

        var varId = parseInt(var_id);  
        var pdtId = parseInt(pdt_id);
      
        if(pdtId==pId){          
        	item.classList.remove('selected-variant');
        }
    }
    
    if(ele.id==item.id){
    	item.classList.add('selected-variant');
    }
  }
  $('#add-all-to-cart').attr('href', allToCart);
}